export const STRINGS = {
  en: {
    scan_title: "Scan & Earn Rewards",
    scan_sub: "Enter the coupon code from your Jewell paint bucket",
    coupon_placeholder: "e.g. JEWEL-DEMO000001",
    validate: "Validate Coupon",
    reward_ready: "Reward Unlocked!",
    choose_reward: "How would you like your reward?",
    wallet: "Points Wallet",
    upi: "UPI Cash",
    gift: "Choose a Gift",
    mobile_title: "Your WhatsApp Number",
    mobile_sub: "We identify you by your mobile number",
    mobile_placeholder: "10-digit mobile number",
    continue: "Continue",
    your_name: "Your Name",
    select_role: "You are a",
    painter: "Painter", contractor: "Contractor", dealer: "Dealer",
    choose_dealer: "Choose your dealer",
    dealer_sub: "Dealer attribution is required for every reward",
    search_dealer: "Search dealer by name, city or PIN",
    confirm_earn: "Confirm & Earn",
    success: "Success!",
    points_added: "points added to your wallet",
    new_balance: "New Wallet Balance",
    reference: "Reference",
    done: "Done",
    consent_text: "I consent to a UPI payout to the account above",
  },
  hi: {
    scan_title: "स्कैन करें और रिवॉर्ड पाएं",
    scan_sub: "अपनी Jewell पेंट बाल्टी का कूपन कोड डालें",
    coupon_placeholder: "जैसे JEWEL-DEMO000001",
    validate: "कूपन जांचें",
    reward_ready: "इनाम अनलॉक!",
    choose_reward: "आप अपना इनाम कैसे चाहते हैं?",
    wallet: "पॉइंट वॉलेट",
    upi: "UPI कैश",
    gift: "उपहार चुनें",
    mobile_title: "आपका WhatsApp नंबर",
    mobile_sub: "हम आपको मोबाइल नंबर से पहचानते हैं",
    mobile_placeholder: "10 अंकों का मोबाइल नंबर",
    continue: "आगे बढ़ें",
    your_name: "आपका नाम",
    select_role: "आप हैं",
    painter: "पेंटर", contractor: "ठेकेदार", dealer: "डीलर",
    choose_dealer: "अपना डीलर चुनें",
    dealer_sub: "हर इनाम के लिए डीलर चुनना ज़रूरी है",
    search_dealer: "नाम, शहर या पिन से डीलर खोजें",
    confirm_earn: "पुष्टि करें और कमाएं",
    success: "सफल!",
    points_added: "पॉइंट आपके वॉलेट में जुड़ गए",
    new_balance: "नया वॉलेट बैलेंस",
    reference: "संदर्भ",
    done: "पूर्ण",
    consent_text: "मैं ऊपर दिए गए खाते में UPI भुगतान के लिए सहमति देता हूँ",
  },
};
